import styled from "styled-components";
import ReactLoading from "react-loading";
import React from "react";

export const LoadingLayer = (props) => {
    return <Styled>
            <ReactLoading width={props.width || "50px"} height={props.width || "50px"} type={"spin"} color={"#009ff5"}/>
    </Styled>
}

const Styled = styled.div`
  width: 100%;
  height: 100%;
  background: rgba(255, 255, 255, 0.8);
  z-index: 1;
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  transition: 500ms;
  border-radius: 13px;

`
